/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `activity` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class ActivityMesg : Mesg {
    public constructor() : super("Activity", Profile.MesgNum.ACTIVITY)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** timestamp. */
    public var timestamp: Instant?
        get() = (getFieldValue(TIMESTAMP_FIELD_NUM) as? UInt)?.let { FitDateTime.toInstant(it) }
        set(value) = setFieldValue(TIMESTAMP_FIELD_NUM, value?.let { FitDateTime.toTimestamp(it) })

    /** total_timer_time, in s. Exclude pauses */
    public var totalTimerTime: Double?
        get() = getFieldValue(TOTAL_TIMER_TIME_FIELD_NUM) as? Double
        set(value) = setFieldValue(TOTAL_TIMER_TIME_FIELD_NUM, value)

    /** num_sessions. */
    public var numSessions: UShort?
        get() = getFieldValue(NUM_SESSIONS_FIELD_NUM) as? UShort
        set(value) = setFieldValue(NUM_SESSIONS_FIELD_NUM, value)

    /** type. */
    public var type: Activity?
        get() = (getFieldValue(TYPE_FIELD_NUM) as? UByte)?.let { Activity.fromValue(it) }
        set(value) = setFieldValue(TYPE_FIELD_NUM, value?.value)

    /** event. */
    public var event: Event?
        get() = (getFieldValue(EVENT_FIELD_NUM) as? UByte)?.let { Event.fromValue(it) }
        set(value) = setFieldValue(EVENT_FIELD_NUM, value?.value)

    /** event_type. */
    public var eventType: EventType?
        get() = (getFieldValue(EVENT_TYPE_FIELD_NUM) as? UByte)?.let { EventType.fromValue(it) }
        set(value) = setFieldValue(EVENT_TYPE_FIELD_NUM, value?.value)

    /** local_timestamp. timestamp epoch expressed in local time, used to convert activity timestamps to local time */
    public var localTimestamp: Instant?
        get() = (getFieldValue(LOCAL_TIMESTAMP_FIELD_NUM) as? UInt)?.let { FitDateTime.toInstant(it) }
        set(value) = setFieldValue(LOCAL_TIMESTAMP_FIELD_NUM, value?.let { FitDateTime.toTimestamp(it) })

    /** event_group. */
    public var eventGroup: UByte?
        get() = getFieldValue(EVENT_GROUP_FIELD_NUM) as? UByte
        set(value) = setFieldValue(EVENT_GROUP_FIELD_NUM, value)

    public companion object {
        public const val TIMESTAMP_FIELD_NUM: UByte = 253u
        public const val TOTAL_TIMER_TIME_FIELD_NUM: UByte = 0u
        public const val NUM_SESSIONS_FIELD_NUM: UByte = 1u
        public const val TYPE_FIELD_NUM: UByte = 2u
        public const val EVENT_FIELD_NUM: UByte = 3u
        public const val EVENT_TYPE_FIELD_NUM: UByte = 4u
        public const val LOCAL_TIMESTAMP_FIELD_NUM: UByte = 5u
        public const val EVENT_GROUP_FIELD_NUM: UByte = 6u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[253] = Field("Timestamp", 253u, BaseType.UINT32, 1.0, 0.0, "", false)
            fields[0] = Field("TotalTimerTime", 0u, BaseType.UINT32, 1000.0, 0.0, "s", false)
            fields[1] = Field("NumSessions", 1u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[2] = Field("Type", 2u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[3] = Field("Event", 3u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[4] = Field("EventType", 4u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[5] = Field("LocalTimestamp", 5u, BaseType.UINT32, 1.0, 0.0, "", false)
            fields[6] = Field("EventGroup", 6u, BaseType.UINT8, 1.0, 0.0, "", false)
            return fields
        }
    }
}
